let globalDispatch: any = null;
let globalNavigate: ((to: string) => void) | null = null;

export const setGlobalDispatch = (dispatch: any) => {
    globalDispatch = dispatch;
};

export const setGlobalNavigate = (navigate: (to: string) => void) => {
    globalNavigate = navigate;
};

export const getGlobalDispatch = () => globalDispatch;
export const getGlobalNavigate = () => globalNavigate;
